@for (tlGroup of tlGroups; track tlGroup) {
  <aa-timeline-group [tlGroup]="tlGroup"></aa-timeline-group>
}
